webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./partials/Cookie.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookieconsent__ = __webpack_require__(/*! cookieconsent */ 36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookieconsent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cookieconsent__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['message', 'button'],

  mounted: function mounted() {
    cookieconsent.initialise({
      container: this.$el,
      position: 'top',
      static: true,
      showLink: false,
      content: {
        message: this.message,
        dismiss: this.button
      }
    });
  }
});

/***/ }),
/* 8 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./partials/CreateNav.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_smooth_scroll__ = __webpack_require__(/*! smooth-scroll */ 40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_smooth_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_smooth_scroll__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['menu', 'languages'],

  created: function created() {
    new __WEBPACK_IMPORTED_MODULE_0_smooth_scroll___default.a('a[data-scroll]');

    this.$mq.desktop && window.addEventListener('scroll', this.scrolling);
  },


  computed: {
    langs: function langs() {
      return this.languages.filter(function (lang) {
        return lang.active === 0;
      });
    },
    nav: function nav() {
      return this.menu.filter(function (item) {
        return item.classes[0] !== 'social';
      });
    },
    social: function social() {
      return this.menu.filter(function (item) {
        return item.classes[0] === 'social';
      });
    }
  },

  methods: {
    scrolling: function scrolling() {
      this.menuScroll = window.scrollY > this.$el.clientHeight;
    },
    className: function className(icon) {
      return 'fa-' + icon;
    },
    flag: function flag(cc) {
      return {
        'en': '🇬🇧',
        'fr': '🇫🇷',
        'de': '🇩🇪'
      }[cc];
    }
  },

  data: function data() {
    return {
      menuOpen: false,
      menuScroll: false
    };
  }
});

/***/ }),
/* 9 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./partials/CreateFooter.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['visit', 'disclaimer', 'menu', 'social'],

  methods: {
    className: function className(icon) {
      return 'fa-' + icon;
    }
  }
});

/***/ }),
/* 10 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Hero.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['content']
});

/***/ }),
/* 11 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/HeroImage.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['content'],

  mounted: function mounted() {
    document.getElementById('app').classList.add('white');
  },


  computed: {
    backgroundImage: function backgroundImage() {
      return 'url(' + this.content.field_HeroImage_image + ')';
    }
  }
});

/***/ }),
/* 12 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/QuarterAndBox.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['content']
});

/***/ }),
/* 13 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/QuarterAndVideo.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['content']
});

/***/ }),
/* 14 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/CentreAndBox.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['content']
});

/***/ }),
/* 15 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/ThreeColumns.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['content']
});

/***/ }),
/* 16 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/FiftyFifty.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['content']
});

/***/ }),
/* 17 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Thirds.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['content']
});

/***/ }),
/* 18 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/FiftyLogos.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['content']
});

/***/ }),
/* 19 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Stats.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['content']
});

/***/ }),
/* 20 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Hub.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_HubItem_vue__ = __webpack_require__(/*! ../partials/HubItem.vue */ 79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isotope_layout__ = __webpack_require__(/*! isotope-layout */ 87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isotope_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isotope_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_imagesloaded__ = __webpack_require__(/*! imagesloaded */ 94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_imagesloaded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_imagesloaded__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['content'],

  data: function data() {
    var params = new URLSearchParams(location.search.slice(1));

    return {
      id: params.get('id')
    };
  },


  components: {
    HubItem: __WEBPACK_IMPORTED_MODULE_0__partials_HubItem_vue__["a" /* default */]
  },

  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_imagesloaded___default()(this.$refs.grid, function () {
      _this.$grid = new __WEBPACK_IMPORTED_MODULE_1_isotope_layout___default.a(_this.$refs.grid, {
        itemSelector: '.grid-item',
        percentPosition: true,
        masonry: {
          columnWidth: '.grid-sizer'
        }
      });
    });
  },


  methods: {
    sizeClass: function sizeClass(i) {
      if (this.content.pieces[i].size !== 'auto') return this.content.pieces[i].size;

      var order = ['thumb left', 'large', 'thumb right', 'large', 'thumb left', 'thumb right', 'thumb left', 'thumb left', 'thumb right', 'thudmb right'];

      return order[i % order.length];
    },
    layout: function layout() {
      this.$grid.arrange();
    }
  }
});

/***/ }),
/* 21 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./partials/HubItem.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HubModal_vue__ = __webpack_require__(/*! ./HubModal.vue */ 81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HubShare_vue__ = __webpack_require__(/*! ./HubShare.vue */ 23);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['piece', 'reveal'],

  components: {
    HubModal: __WEBPACK_IMPORTED_MODULE_0__HubModal_vue__["a" /* default */],
    HubShare: __WEBPACK_IMPORTED_MODULE_1__HubShare_vue__["a" /* default */]
  },

  data: function data() {
    return {
      modalOpen: this.$mq.desktop && this.piece.id == this.reveal,
      expandOpen: !this.$mq.desktop && this.piece.id == this.reveal
    };
  },


  methods: {
    open: function open() {
      var _this = this;

      this.$mq.desktop ? this.modalOpen = true : this.expandOpen = true;

      this.$nextTick(function () {
        return _this.$emit('layout');
      });
    },
    close: function close() {
      var _this2 = this;

      this.$mq.desktop ? this.modalOpen = false : this.expandOpen = false;

      this.$nextTick(function () {
        return _this2.$emit('layout');
      });
    }
  },

  computed: {
    title: function title() {
      return '\u201C' + this.piece.title + '\u201D';
    },
    playable: function playable() {
      return !!this.piece.video;
    }
  }
});

/***/ }),
/* 22 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./partials/HubModal.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HubShare_vue__ = __webpack_require__(/*! ./HubShare.vue */ 23);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['piece', 'open'],

  components: {
    HubShare: __WEBPACK_IMPORTED_MODULE_0__HubShare_vue__["a" /* default */]
  }
});

/***/ }),
/* 23 */
/*!*******************************!*\
  !*** ./partials/HubShare.vue ***!
  \*******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_HubShare_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./HubShare.vue */ 24);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d20b5d2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HubShare_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2d20b5d2","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./HubShare.vue */ 84);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-2d20b5d2","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./HubShare.vue */ 83)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d20b5d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_HubShare_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d20b5d2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HubShare_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 24 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./partials/HubShare.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['piece'],

  computed: {
    facebook: function facebook() {
      return 'https://www.facebook.com/sharer/sharer.php?u=' + this.piece.share;
    },
    twitter: function twitter() {
      return 'https://twitter.com/intent/tweet?url=' + this.piece.share;
    }
  }
});

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */
/*!************************!*\
  !*** multi ./index.js ***!
  \************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/index.js */28);


/***/ }),
/* 28 */
/*!******************!*\
  !*** ./index.js ***!
  \******************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_match_media_src__ = __webpack_require__(/*! vue-match-media/src */ 32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_scss__ = __webpack_require__(/*! ./index.scss */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_Cookie__ = __webpack_require__(/*! ./partials/Cookie */ 34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_CreateNav__ = __webpack_require__(/*! ./partials/CreateNav */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partials_CreateFooter__ = __webpack_require__(/*! ./partials/CreateFooter */ 44);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_match_media_src__["a" /* default */]);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('hero', __webpack_require__(/*! ./components/Hero */ 47).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('hero-image', __webpack_require__(/*! ./components/HeroImage */ 50).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('quarter-and-box', __webpack_require__(/*! ./components/QuarterAndBox */ 53).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('quarter-and-video', __webpack_require__(/*! ./components/QuarterAndVideo */ 56).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('centre-and-box', __webpack_require__(/*! ./components/CentreAndBox */ 59).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('three-columns', __webpack_require__(/*! ./components/ThreeColumns */ 62).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('fifty-fifty', __webpack_require__(/*! ./components/FiftyFifty */ 65).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('thirds', __webpack_require__(/*! ./components/Thirds */ 68).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('fifty-logos', __webpack_require__(/*! ./components/FiftyLogos */ 71).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('stats', __webpack_require__(/*! ./components/Stats */ 74).default);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('hub', __webpack_require__(/*! ./components/Hub */ 77).default);

var content = {};
var router = {};
if (false) {
  content = require('./content.json');

  var VueRouter = require('vue-router').default;
  Vue.use(VueRouter);

  var Home = require('./pages/Home.vue').default;
  var Hub = require('./pages/Hub.vue').default;
  var NewHome = require('./pages/NewHome.vue').default;
  var Hygeine = require('./pages/Hygeine.vue').default;

  router = new VueRouter({
    mode: 'history',
    routes: [{ path: '/', redirect: '/home' }, { path: '/home', component: Home }, { path: '/new', component: NewHome, props: { content: content } }, { path: '/hub', component: Hub, props: { content: content } }, { path: '/hygeine', component: Hygeine }]
  });
}

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  mq: {
    phone: '(max-width: 768px)',
    tablet: '(max-width: 1024px)',
    desktop: '(min-width: 1024px)'
  },
  components: {
    Cookie: __WEBPACK_IMPORTED_MODULE_3__partials_Cookie__["a" /* default */],
    CreateNav: __WEBPACK_IMPORTED_MODULE_4__partials_CreateNav__["a" /* default */],
    CreateFooter: __WEBPACK_IMPORTED_MODULE_5__partials_CreateFooter__["a" /* default */]
  },
  data: {
    content: content
  },
  router: router
});

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/*!********************!*\
  !*** ./index.scss ***!
  \********************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */
/*!*****************************!*\
  !*** ./partials/Cookie.vue ***!
  \*****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Cookie_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./Cookie.vue */ 7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f5828c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cookie_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1f5828c0","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./Cookie.vue */ 37);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1f5828c0","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./Cookie.vue */ 35)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Cookie_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f5828c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cookie_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 35 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1f5828c0","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./partials/Cookie.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */,
/* 37 */
/*!******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f5828c0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./partials/Cookie.vue ***!
  \******************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 38 */
/*!********************************!*\
  !*** ./partials/CreateNav.vue ***!
  \********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_CreateNav_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./CreateNav.vue */ 8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_226f962a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateNav_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-226f962a","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./CreateNav.vue */ 41);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-226f962a","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./CreateNav.vue */ 39)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-226f962a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_CreateNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_226f962a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 39 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-226f962a","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./partials/CreateNav.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */,
/* 41 */
/*!********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-226f962a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./partials/CreateNav.vue ***!
  \********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar",class:{ 'scroll': _vm.menuScroll },attrs:{"id":"top","role":"navigation","aria-label":"main navigation"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-brand",class:{ 'is-active': _vm.menuOpen }},[_c('button',{staticClass:"button navbar-burger",class:{ 'is-active': _vm.menuOpen },on:{"click":function($event){_vm.menuOpen = !_vm.menuOpen}}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])]),_vm._v(" "),_c('transition',{attrs:{"name":"height"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$mq.desktop || _vm.menuOpen),expression:"$mq.desktop || menuOpen"}],staticClass:"navbar-menu is-active"},[_c('div',{staticClass:"navbar-start"}),_vm._v(" "),_c('div',{staticClass:"navbar-end"},[_vm._l((_vm.nav),function(link){return _c('a',{key:link.title,staticClass:"navbar-item",class:link.classes,attrs:{"href":link.url}},[_vm._v("\n              "+_vm._s(link.title)+"\n            ")])}),_vm._v(" "),_vm._l((_vm.social),function(link){return _c('a',{key:link.title,staticClass:"navbar-item icon is-large",class:link.classes,attrs:{"href":link.url}},[_c('i',{staticClass:"fa fa-2x",class:_vm.className(link.classes[1])})])}),_vm._v(" "),_vm._l((_vm.langs),function(lang){return _c('a',{key:lang.id,staticClass:"navbar-item flag",attrs:{"href":lang.url}},[_vm._v("\n              "+_vm._s(_vm.flag(lang.code))+"\n            ")])})],2)])])],1)]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section mobile-logo is-hidden-desktop"},[_c('div',{staticClass:"container"},[_c('img',{staticClass:"blue-logo",attrs:{"src":__webpack_require__(/*! ../assets/logo.svg */ 42),"alt":"Purpose Create","width":"457","height":"44"}}),_vm._v(" "),_c('img',{staticClass:"white-logo",attrs:{"src":__webpack_require__(/*! ../assets/logo-white.svg */ 43),"alt":"Purpose Create","width":"457","height":"44"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 42 */
/*!*************************!*\
  !*** ./assets/logo.svg ***!
  \*************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/logo.3aad4f6c.svg";

/***/ }),
/* 43 */
/*!*******************************!*\
  !*** ./assets/logo-white.svg ***!
  \*******************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/logo-white.23ea843a.svg";

/***/ }),
/* 44 */
/*!***********************************!*\
  !*** ./partials/CreateFooter.vue ***!
  \***********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_CreateFooter_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./CreateFooter.vue */ 9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35adbf6d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateFooter_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-35adbf6d","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./CreateFooter.vue */ 46);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-35adbf6d","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./CreateFooter.vue */ 45)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35adbf6d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_CreateFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35adbf6d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 45 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35adbf6d","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./partials/CreateFooter.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */
/*!***********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35adbf6d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./partials/CreateFooter.vue ***!
  \***********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"square"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"social"},_vm._l((_vm.social),function(icon){return _c('a',{key:icon.icon,staticClass:"icon is-large",attrs:{"href":icon.url}},[_c('i',{staticClass:"fa fa-3x",class:_vm.className(icon.icon)})])})),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.visit))]),_vm._v(" "),_c('p',{staticClass:"links"},_vm._l((_vm.menu),function(link){return _c('a',{key:link.title,attrs:{"href":link.url}},[_vm._v(_vm._s(link.title))])}))])])]),_vm._v(" "),_c('div',{staticClass:"cc"},[_c('span',[_vm._v(_vm._s(_vm.disclaimer))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 47 */
/*!*****************************!*\
  !*** ./components/Hero.vue ***!
  \*****************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Hero_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./Hero.vue */ 10);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bda01c8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hero_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2bda01c8","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./Hero.vue */ 49);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-2bda01c8","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./Hero.vue */ 48)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bda01c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Hero_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bda01c8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hero_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 48 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2bda01c8","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/Hero.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/*!*****************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bda01c8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Hero.vue ***!
  \*****************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",attrs:{"id":_vm.content.field_Hero_fragment_id}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"video"},[_c('div',{staticClass:"embed-container",domProps:{"innerHTML":_vm._s(_vm.content.field_Hero_video)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 50 */
/*!**********************************!*\
  !*** ./components/HeroImage.vue ***!
  \**********************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_HeroImage_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./HeroImage.vue */ 11);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1db4ec88_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeroImage_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1db4ec88","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./HeroImage.vue */ 52);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1db4ec88","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./HeroImage.vue */ 51)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1db4ec88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_HeroImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1db4ec88_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeroImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 51 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1db4ec88","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/HeroImage.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/*!**********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1db4ec88","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/HeroImage.vue ***!
  \**********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",style:({ backgroundImage: _vm.backgroundImage })},[_c('div',{staticClass:"screen1"}),_vm._v(" "),_c('div',{staticClass:"screen2"}),_vm._v(" "),_c('video',{staticClass:"video",attrs:{"src":_vm.content.field_HeroImage_video_url,"width":"1920","height":"1080","autoplay":"","muted":"","loop":""},domProps:{"muted":true}}),_vm._v(" "),_c('div',{staticClass:"text is-size-3"},[_vm._v(_vm._s(_vm.content.field_HeroImage_Text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 53 */
/*!**************************************!*\
  !*** ./components/QuarterAndBox.vue ***!
  \**************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_QuarterAndBox_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./QuarterAndBox.vue */ 12);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f21e674_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuarterAndBox_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4f21e674","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./QuarterAndBox.vue */ 55);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-4f21e674","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./QuarterAndBox.vue */ 54)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f21e674"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_QuarterAndBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f21e674_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuarterAndBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 54 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f21e674","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/QuarterAndBox.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f21e674","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/QuarterAndBox.vue ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",attrs:{"id":_vm.content.field_QuarterAndBox_fragment_id}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-desktop"},[_c('div',{staticClass:"column is-one-quarter-desktop"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content.field_QuarterAndBox_left_content)}})]),_vm._v(" "),_c('div',{staticClass:"cube"},[_c('div',{staticClass:"square"},[_c('span',[_vm._v(_vm._s(_vm.content.field_QuarterAndBox_box))])])]),_vm._v(" "),_c('div',{staticClass:"column is-three-quarters-desktop"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.content.field_QuarterAndBox_right_heading))]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"is-hidden-mobile",domProps:{"innerHTML":_vm._s(_vm.content.field_QuarterAndBox_desktop_image)}}),_vm._v(" "),_c('p',{staticClass:"is-hidden-tablet",domProps:{"innerHTML":_vm._s(_vm.content.field_QuarterAndBox_mobile_image)}}),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.content.field_QuarterAndBox_caption))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 56 */
/*!****************************************!*\
  !*** ./components/QuarterAndVideo.vue ***!
  \****************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_QuarterAndVideo_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./QuarterAndVideo.vue */ 13);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_083abdaa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuarterAndVideo_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-083abdaa","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./QuarterAndVideo.vue */ 58);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-083abdaa","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./QuarterAndVideo.vue */ 57)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-083abdaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_QuarterAndVideo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_083abdaa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuarterAndVideo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 57 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-083abdaa","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/QuarterAndVideo.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/*!****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-083abdaa","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/QuarterAndVideo.vue ***!
  \****************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":_vm.content.field_QuarterAndVideo_fragment_id}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content.field_QuarterAndVideo_left_content)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 59 */
/*!*************************************!*\
  !*** ./components/CentreAndBox.vue ***!
  \*************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_CentreAndBox_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./CentreAndBox.vue */ 14);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dace7e4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CentreAndBox_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7dace7e4","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./CentreAndBox.vue */ 61);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7dace7e4","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./CentreAndBox.vue */ 60)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7dace7e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_CentreAndBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dace7e4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CentreAndBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 60 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7dace7e4","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/CentreAndBox.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/*!*************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dace7e4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/CentreAndBox.vue ***!
  \*************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",attrs:{"id":_vm.content.field_CentreAndBox_fragment_id}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"cube"},[_c('div',{staticClass:"square"},[_c('span',[_vm._v(_vm._s(_vm.content.field_CentreAndBox_box))])])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.content.field_CentreAndBox_heading))]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"is-hidden-mobile",domProps:{"innerHTML":_vm._s(_vm.content.field_CentreAndBox_desktop_image)}}),_vm._v(" "),_c('p',{staticClass:"is-hidden-tablet",domProps:{"innerHTML":_vm._s(_vm.content.field_CentreAndBox_mobile_image)}}),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.content.field_CentreAndBox_caption))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 62 */
/*!*************************************!*\
  !*** ./components/ThreeColumns.vue ***!
  \*************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ThreeColumns_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./ThreeColumns.vue */ 15);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77b68403_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreeColumns_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-77b68403","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./ThreeColumns.vue */ 64);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-77b68403","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./ThreeColumns.vue */ 63)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77b68403"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ThreeColumns_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77b68403_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThreeColumns_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 63 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77b68403","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/ThreeColumns.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */
/*!*************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77b68403","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/ThreeColumns.vue ***!
  \*************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('h2',{staticClass:"title is-size-3"},[_vm._v(_vm._s(_vm.content.field_ThreeColumns_left))])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('a',{staticClass:"cube cube-download",attrs:{"href":_vm.content.field_ThreeColumns_box_1_url,"target":"_blank"}},[_c('div',{staticClass:"square"},[_c('span',[_vm._v(_vm._s(_vm.content.field_ThreeColumns_box_1_text))])])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('a',{staticClass:"cube cube-apply",attrs:{"href":_vm.content.field_ThreeColumns_box_2_url,"target":"_blank"}},[_c('div',{staticClass:"square"},[_c('span',[_vm._v(_vm._s(_vm.content.field_ThreeColumns_box_2_text))])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 65 */
/*!***********************************!*\
  !*** ./components/FiftyFifty.vue ***!
  \***********************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FiftyFifty_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./FiftyFifty.vue */ 16);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e25ce8c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiftyFifty_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7e25ce8c","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./FiftyFifty.vue */ 67);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-7e25ce8c","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./FiftyFifty.vue */ 66)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e25ce8c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FiftyFifty_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e25ce8c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiftyFifty_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 66 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e25ce8c","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/FiftyFifty.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/*!***********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e25ce8c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FiftyFifty.vue ***!
  \***********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":_vm.content.field_FiftyFifty_fragment_id}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content.field_FiftyFifty_left_content)}}),_vm._v(" "),_c('div',{staticClass:"cubes"},[_c('a',{staticClass:"cube cube-download",attrs:{"href":_vm.content.field_FiftyFifty_box_1_file,"target":"_blank"}},[_c('div',{staticClass:"square"},[_c('span',[_vm._v(_vm._s(_vm.content.field_FiftyFifty_box_1_text))])])]),_vm._v(" "),_c('a',{staticClass:"cube cube-apply",attrs:{"href":_vm.content.field_FiftyFifty_box_2_url,"target":"_blank"}},[_c('div',{staticClass:"square"},[_c('span',[_vm._v(_vm._s(_vm.content.field_FiftyFifty_box_2_text))])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 68 */
/*!*******************************!*\
  !*** ./components/Thirds.vue ***!
  \*******************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Thirds_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./Thirds.vue */ 17);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_728ca388_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Thirds_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-728ca388","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./Thirds.vue */ 70);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-728ca388","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./Thirds.vue */ 69)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-728ca388"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Thirds_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_728ca388_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Thirds_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 69 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-728ca388","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/Thirds.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */
/*!*******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-728ca388","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Thirds.vue ***!
  \*******************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",attrs:{"id":_vm.content.field_Thirds_fragment_id}},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.content.field_Thirds_title))]),_vm._v(" "),_c('div',{staticClass:"columns is-desktop"},_vm._l((_vm.content.field_Thirds_columns),function(col,i){return _c('div',{key:i,staticClass:"column"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"img",domProps:{"innerHTML":_vm._s(col.field_Thirds_image)}}),_vm._v(" "),_c('h4',{staticClass:"subtitle"},[_vm._v(_vm._s(col.field_Thirds_heading))])]),_vm._v(" "),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(col.field_Thirds_content)}})])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 71 */
/*!***********************************!*\
  !*** ./components/FiftyLogos.vue ***!
  \***********************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FiftyLogos_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./FiftyLogos.vue */ 18);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c032922_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiftyLogos_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-9c032922","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./FiftyLogos.vue */ 73);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-9c032922","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./FiftyLogos.vue */ 72)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9c032922"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FiftyLogos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c032922_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FiftyLogos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 72 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9c032922","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/FiftyLogos.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */
/*!***********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c032922","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FiftyLogos.vue ***!
  \***********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",attrs:{"id":_vm.content.field_FiftyLogos_fragment_id}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-half"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content.field_FiftyLogos_left_content)}})]),_vm._v(" "),_c('div',{staticClass:"column is-half"},[_c('div',{staticClass:"gallery"},_vm._l((_vm.content.logos),function(logo,i){return _c('a',{key:i,attrs:{"href":_vm.content.urls[i]}},[_c('figure',{staticClass:"image is-128x128"},[_c('img',{attrs:{"src":logo}})])])}))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 74 */
/*!******************************!*\
  !*** ./components/Stats.vue ***!
  \******************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./Stats.vue */ 19);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39012cec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-39012cec","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./Stats.vue */ 76);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-39012cec","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./Stats.vue */ 75)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39012cec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39012cec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 75 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-39012cec","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/Stats.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/*!******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39012cec","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Stats.vue ***!
  \******************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",attrs:{"id":_vm.content.field_QuarterAndBox_fragment_id}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-desktop"},_vm._l((_vm.content.field_Stats_boxes),function(box){return _c('div',{key:box.caption,staticClass:"column"},[_c('div',{staticClass:"cube",style:({ marginTop: (_vm.$mq.desktop ? box.field_Stats_vertical_offset : 0) + 'px' })},[_c('div',{staticClass:"square"},[_c('span',[_vm._v(_vm._s(box.field_Stats_number))])])]),_vm._v(" "),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(box.field_Stats_caption))])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 77 */
/*!****************************!*\
  !*** ./components/Hub.vue ***!
  \****************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Hub_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./Hub.vue */ 20);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31ef9fc3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hub_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-31ef9fc3","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./Hub.vue */ 95);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-31ef9fc3","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./Hub.vue */ 78)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31ef9fc3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Hub_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31ef9fc3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hub_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 78 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-31ef9fc3","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/Hub.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 79 */
/*!******************************!*\
  !*** ./partials/HubItem.vue ***!
  \******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_HubItem_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./HubItem.vue */ 21);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f9b34b2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HubItem_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-5f9b34b2","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./HubItem.vue */ 86);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-5f9b34b2","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./HubItem.vue */ 80)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f9b34b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_HubItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f9b34b2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HubItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 80 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f9b34b2","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./partials/HubItem.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/*!*******************************!*\
  !*** ./partials/HubModal.vue ***!
  \*******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_HubModal_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/Users/matthewlima/Documents/github/create-refresh/wp-content/themes/create/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../node_modules/vue-loader/lib/selector?type=script&index=0!./HubModal.vue */ 22);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f45dded2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HubModal_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-f45dded2","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./HubModal.vue */ 85);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-f45dded2","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./HubModal.vue */ 82)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f45dded2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_Users_matthewlima_Documents_github_create_refresh_wp_content_themes_create_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_HubModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f45dded2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HubModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 82 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f45dded2","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./partials/HubModal.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2d20b5d2","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./partials/HubShare.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/*!*******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d20b5d2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./partials/HubShare.vue ***!
  \*******************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social"},[_c('span',{staticClass:"icon"},[_c('a',{attrs:{"href":_vm.twitter,"target":"_blank"}},[_c('i',{staticClass:"fa fa-twitter"})])]),_vm._v(" "),_c('span',{staticClass:"icon"},[_c('a',{attrs:{"href":_vm.facebook,"target":"_blank"}},[_c('i',{staticClass:"fa fa-facebook"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 85 */
/*!*******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f45dded2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./partials/HubModal.vue ***!
  \*******************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.open)?_c('div',{staticClass:"modal",class:[_vm.piece.type, { 'is-active': _vm.open }]},[_c('div',{staticClass:"modal-background",on:{"click":function($event){_vm.$emit('close')}}}),_vm._v(" "),_c('div',{staticClass:"modal-content"},[(!_vm.piece.video)?_c('div',{staticClass:"content-image"},[_c('div',{staticClass:"figure"},[_c('figure',{staticClass:"image is-square"},[_c('img',{attrs:{"src":_vm.piece.image}})])]),_vm._v(" "),_c('div',{staticClass:"caption"},[_c('div',{staticClass:"meta"},[_c('div',{staticClass:"author"},[_vm._v(_vm._s(_vm.piece.author)+",")]),_vm._v(" "),_c('div',{staticClass:"occupation"},[_vm._v(_vm._s(_vm.piece.occupation))])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.piece.description)}}),_vm._v(" "),(_vm.piece.url && _vm.piece.visit)?_c('p',{staticStyle:{"margin-top":"1rem"}},[_c('a',{attrs:{"target":"_blank","href":_vm.piece.url}},[_vm._v(_vm._s(_vm.piece.visit))])]):_vm._e()])])]):_c('div',[_c('div',{staticClass:"content-video"},[_c('div',{staticClass:"figure"},[_c('div',{staticClass:"embed-container",domProps:{"innerHTML":_vm._s(_vm.piece.video)}})]),_vm._v(" "),_c('div',{staticClass:"caption"},[_c('div',{staticClass:"meta"},[_c('div',{staticClass:"author"},[_vm._v(_vm._s(_vm.piece.author)+",")]),_vm._v(" "),_c('div',{staticClass:"occupation"},[_vm._v(_vm._s(_vm.piece.occupation))])]),_vm._v(" "),(_vm.piece.url && _vm.piece.visit)?_c('p',[_c('a',{attrs:{"target":"_blank","href":_vm.piece.url}},[_vm._v(_vm._s(_vm.piece.visit))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"video-description"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.piece.description)}})])]),_vm._v(" "),_c('hub-share',{attrs:{"piece":_vm.piece}})],1),_vm._v(" "),_c('button',{staticClass:"modal-close is-large",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.$emit('close')}}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 86 */
/*!******************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f9b34b2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./partials/HubItem.vue ***!
  \******************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",class:_vm.piece.type},[_c('div',{staticClass:"figure",on:{"click":_vm.open}},[_c('figure',{staticClass:"image is-square"},[_c('img',{attrs:{"src":_vm.piece.image}}),_vm._v(" "),(_vm.playable)?_c('div',{staticClass:"play"}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"caption"},[_c('div',{staticClass:"caption-props",on:{"click":_vm.open}},[_c('div',{staticClass:"name",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('div',{staticClass:"meta"},[_c('div',{staticClass:"author"},[_vm._v(_vm._s(_vm.piece.author)+",")]),_vm._v(" "),_c('div',{staticClass:"occupation"},[_vm._v(_vm._s(_vm.piece.occupation))])])]),_vm._v(" "),(_vm.expandOpen)?_c('div',{staticClass:"expanded"},[_c('div',{staticClass:"content"},[(_vm.piece.video)?_c('div',{staticClass:"embed-container",domProps:{"innerHTML":_vm._s(_vm.piece.video)}}):_vm._e(),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.piece.description)}}),_vm._v(" "),(_vm.piece.url && _vm.piece.visit)?_c('p',{staticStyle:{"margin-top":"1rem"}},[_c('a',{attrs:{"target":"_blank","href":_vm.piece.url}},[_vm._v(_vm._s(_vm.piece.visit))])]):_vm._e()]),_vm._v(" "),_c('a',{staticClass:"delete",on:{"click":_vm.close}}),_vm._v(" "),_c('hub-share',{attrs:{"piece":_vm.piece}})],1):_vm._e()]),_vm._v(" "),_c('hub-modal',{attrs:{"piece":_vm.piece,"open":_vm.modalOpen,"visit":_vm.piece.visit},on:{"close":_vm.close}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/*!****************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31ef9fc3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Hub.vue ***!
  \****************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{ref:"grid",staticClass:"grid"},[_c('div',{staticClass:"grid-sizer"}),_vm._v(" "),_vm._l((_vm.content.pieces),function(piece,i){return _c('hub-item',{key:piece.title,staticClass:"grid-item",class:_vm.sizeClass(i),attrs:{"piece":piece,"reveal":_vm.id},on:{"layout":_vm.layout}})})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[27]);


// WEBPACK FOOTER //
// client.js